import axios from './axiosInstance';
import { APIForm } from '../../types';

interface SportAreaParams {
  sport: string;
  areaId: string;
}

interface FormMutationParams extends SportAreaParams {
  form: APIForm;
}

interface GetFormParams extends SportAreaParams {
  formId: string;
}

interface GetFormsParams extends SportAreaParams {
  includeUllrDefaults?: boolean;
  formType?: string;
}

interface PostSettingsParams extends SportAreaParams {
  body: Record<string, any>;
}

interface DeleteFormParams extends SportAreaParams {
  formId: string;
}

const createForm = ({ sport, areaId, form }: FormMutationParams): Promise<APIForm> => {
  let url = `/${sport}/areas/${areaId}/trailissueforms`;
  return axios.put(url, form)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
}

const updateForm = ({ sport, areaId, form }: FormMutationParams): Promise<APIForm> => {
  let url = `/${sport}/areas/${areaId}/trailissueforms/${form.id}`;
  return axios.post(url, form)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
}

const getForm = ({ sport, areaId, formId }: GetFormParams): Promise<APIForm> => {
  let url = `/${sport}/areas/${areaId}/trailissueforms/${formId}`;
  return axios.get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const getForms = ({ sport, areaId, includeUllrDefaults, formType }: GetFormsParams): Promise<APIForm[]> => {
  let url = `/${sport}/areas/${areaId}/trailissueforms`;
  if (formType) {
    url += `/${formType}`;
  } else if (includeUllrDefaults !== undefined) {
    url += `?includeUllrDefaults=${includeUllrDefaults}`
  }
  return axios.get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const getSettings = ({ sport, areaId }: SportAreaParams): Promise<any> => {
  let url = `/${sport}/areas/${areaId}/trailissueforms/settings`;
  return axios.get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const postSettings = ({ sport, areaId, body }: PostSettingsParams): Promise<any> => {
  let url = `/${sport}/areas/${areaId}/trailissueforms/settings`;
  return axios.post(url, body)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const deleteForm = ({ sport, areaId, formId }: DeleteFormParams): Promise<void> => {
  let url = `/${sport}/areas/${areaId}/trailissueforms/${formId}`;
  return axios.delete(url)
    .then(() => {})
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const formFunctions = {
  createForm,
  updateForm,
  getForm,
  getForms,
  getSettings,
  postSettings,
  deleteForm,
};

export default formFunctions;
